/* eslint-disable */
import { call, AddVideoLinkResponse } from 'services/api-service'

/**
 * Post a video link for validation and return details
 *
 * @method
 * @name ApiService#addVideoLink
 * @param {string} url -
 */
function addVideoLink(parameters: { url: string }): Promise<AddVideoLinkResponse> {
  return call<AddVideoLinkResponse>(
    'POST',
    '/{siteKey}/media/videoLink',
    parameters,
    ['url'],
    ['url'],
    []
  )
}

export default { addVideoLink }
